import * as Application from 'expo-application';
import { Platform } from 'react-native';

// eslint-disable-next-line @typescript-eslint/no-var-requires
const packageJson = require('../package.json');

export const APP_VERSION = packageJson.version as string;
// Web has no native build number; `npm run build` stamps the deployed commit instead.
export const BUILD_NUMBER =
  Platform.OS === 'web'
    ? (process.env.EXPO_PUBLIC_WEB_BUILD ?? null)
    : Application.nativeBuildVersion;
export const VERSION_WITH_BUILD = BUILD_NUMBER ? `${APP_VERSION}-${BUILD_NUMBER}` : APP_VERSION;

// Sentry release. The platform is encoded in the version segment (the part Sentry
// shows prominently in the Releases list, not the truncated package) so iOS / Android /
// web are easy to tell apart — the bundle id is identical on iOS and Android, so without
// this they only differed by build number:
// - iOS/Android: {bundleId}@{version}-{platform}+{buildNumber}  → e.g. 6.1.8-ios (779)
// - Web: {version}-web (the upload-sourcemaps script sets a matching SENTRY_RELEASE); the build
//   ID goes in dist, so same-version redeploys share one release
// Source maps resolve by Debug ID, so the release name is free-form.
const APP_ID = Application.applicationId;
export const SENTRY_RELEASE =
  APP_ID && BUILD_NUMBER
    ? `${APP_ID}@${APP_VERSION}-${Platform.OS}+${BUILD_NUMBER}`
    : `${APP_VERSION}-${Platform.OS}`;
